import { t } from './config'
import { escapeHTML } from './richText'

// Inline, so the icons take the button's colour.
const THUMB_UP = '<path d="M7 10v12"/><path d="M15 5.88 14 10h5.83a2 2 0 0 1 1.92 2.56l-2.33 8A2 2 0 0 1 17.5 22H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h2.76a2 2 0 0 0 1.79-1.11L12 2a3.13 3.13 0 0 1 3 3.88Z"/>'
const THUMB_DOWN = '<path d="M17 14V2"/><path d="M9 18.12 10 14H4.17a2 2 0 0 1-1.92-2.56l2.33-8A2 2 0 0 1 6.5 2H20a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-2.76a2 2 0 0 0-1.79 1.11L12 22a3.13 3.13 0 0 1-3-3.88Z"/>'

const send = (submit, root, state) => submit({ message_id: root.dataset.replyId, ...state })

// A rating is sent at once, so it counts if the shopper skips the note.
export const createReplyFeedback = (container, submit) => {
  // Pressing a button would blur the note first: on mobile the composer then comes
  // back, the panel moves, and the tap lands beside the button.
  container.addEventListener('mousedown', event => {
    if (event.target.closest('.vjs-vera-reply-feedback-panel button')) event.preventDefault()
  })

  container.addEventListener('input', event => {
    if (!event.target.closest('.vjs-vera-reply-feedback-panel .vjs-vera-note')) return
    const root = event.target.closest('.vjs-vera-reply-feedback')
    root.querySelector('.vjs-vera-reply-feedback-submit').disabled = !event.target.value.trim()
  })

  container.addEventListener('click', event => {
    const root = event.target.closest('.vjs-vera-reply-feedback')
    if (!root) return

    const verdictButton = event.target.closest('.vjs-vera-reply-verdict')
    if (verdictButton) {
      const verdict = verdictButton.dataset.verdict
      verdictButton.classList.add('is-selected')
      verdictButton.setAttribute('aria-pressed', 'true')
      root.querySelectorAll('.vjs-vera-reply-verdict').forEach(button => { button.disabled = true })
      root.dataset.rating = verdict
      send(submit, root, { verdict })

      root.querySelector('.vjs-vera-reply-feedback-heading').textContent = t(`reply_feedback.${verdict}_heading`)
      root.querySelector('.vjs-vera-reply-feedback-panel').hidden = false
      return
    }

    if (event.target.closest('.vjs-vera-reply-feedback-submit')) {
      send(submit, root, { verdict: root.dataset.rating, note: root.querySelector('.vjs-vera-note').value.trim() })
      return thank(root)
    }

    if (event.target.closest('.vjs-vera-reply-feedback-skip')) thank(root)
  })

  return { html: replyFeedbackHTML }
}

export const replyFeedbackHTML = messageId => `
    <div class="vsd-vera-reply-feedback vjs-vera-reply-feedback" data-reply-id="${escapeHTML(messageId)}">
      <div class="vsd-vera-reply-feedback__pill" role="group" aria-label="${t('reply_feedback.label')}">
        ${verdictHTML('helpful', THUMB_UP)}
        <span class="vsd-vera-reply-feedback__divider" aria-hidden="true"></span>
        ${verdictHTML('not_helpful', THUMB_DOWN)}
      </div>
      <div class="vsd-vera-feedback__panel vsd-vera-reply-feedback__panel vjs-vera-reply-feedback-panel" hidden>
        <div class="flex items-baseline justify-between mb-12">
          <span class="vsd-vera-feedback__panel-title vjs-vera-reply-feedback-heading"></span>
          <button type="button" class="vsd-vera-feedback__back vjs-vera-reply-feedback-skip">${t('reply_feedback.skip')}</button>
        </div>
        <textarea class="vsd-vera-feedback__note vjs-vera-note" rows="3" maxlength="500" placeholder="${t('reply_feedback.note_placeholder')}"></textarea>
        <button type="button" class="vsd-vera-feedback__submit vjs-vera-reply-feedback-submit" disabled>${t('reply_feedback.submit')}</button>
      </div>
    </div>
  `

const verdictHTML = (verdict, icon) => `
    <button type="button" class="vsd-vera-reply-feedback__verdict vjs-vera-reply-verdict" data-verdict="${verdict}" aria-pressed="false">
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${icon}</svg>
      <span>${t(`reply_feedback.${verdict}`)}</span>
    </button>
  `

// Blurred first: a removed field sends no focusout, which would leave the composer hidden on mobile.
const thank = root => {
  if (root.contains(document.activeElement)) document.activeElement.blur()
  root.innerHTML = `<p class="vsd-vera-reply-feedback__thanks" role="status">${t('reply_feedback.thanks')}</p>`
}
